import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api, callApiUpdateUser } from "../../services/index";

import { setStorageItem, removeAllStorage } from "../../helpers";

import {
  USER_STATUS_CHANGED_SUCCESS,
  USER_STATUS_CHANGED_FAILURE,
} from "../types";

export const onClickChangeUserStatus = (data) => {
  return async (dispatch) => {
    if (data) {
      console.log("Inside user action");

      return callApiUpdateUser({
        purpose: data.purpose,
        userId: data.userId,
        userStatus: data.userStatus,
      })
        .then(async (res) => {
          dispatch({
            type: USER_STATUS_CHANGED_SUCCESS,
            payload: res,
          });

          if (res.success === true) {
            toast.success("User status changed successfully", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2500,
            });
          }
        })
        .catch((error) => {
          console.log("user fetch data ... error", error);
        });
    }
  };
};
